{
    "Policies_Incomplete.search.assignedTo": "Assigned To",
    "Policies_Incomplete.search.allBrokers": "All Brokers",
    "Policies_Incomplete.search.allProducts": "All Products",
    "Policies_Incomplete.search.phone": "Phone",
    "Policies_Incomplete.search.email": "Email",
    "Policies_Incomplete.search.clear": "Clear",

    "Policies_Incomplete.table.referenceNumber": "Reference Number",
    "Policies_Incomplete.table.policyNumber": "Policy Number",
    "Policies_Incomplete.table.name": "Name",
    "Policies_Incomplete.table.product": "Product",
    "Policies_Incomplete.table.creationDate": "Creation Date",
    "Policies_Incomplete.table.assignedTo": "Assigned To",
    "Policies_Incomplete.table.type": "Type",
    "Policies_Incomplete.search.fname": "First Name",
    "Policies_Incomplete.search.lname": "Last Name",
    "Policies_Incomplete.search.search": "Search"
}
